import script from "./page-bottom.vue?vue&type=script&setup=true&lang=js"
export * from "./page-bottom.vue?vue&type=script&setup=true&lang=js"

import "./page-bottom.vue?vue&type=style&index=0&id=5ca92efa&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.40_vue@3.5.40_webpack@5.108.4_postcss@8.5.22_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ca92efa"]])

export default __exports__